var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (value) {
if ( value.selectable)
{
if ( value.single)
{
buf.push("<input type=\"radio\"" + (jade.attr("checked", value.checked, true, true)) + (jade.attr("aria-labelledby", value.labelbyId, true, true)) + " class=\"select-row\">");
}
else
{
buf.push("<input type=\"checkbox\"" + (jade.attr("checked", value.checked, true, true)) + (jade.attr("aria-labelledby", value.labelbyId, true, true)) + " class=\"select-row\">");
}
}
else
{
buf.push("<span class=\"unselectable\"></span>");
}}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/vnext/projection/selection-body.jade
// module id = 80
// module chunks = 0